/**
 * recordingRequestModal.tsx
 */
import Buttons from '@components/elements/modal/recordingRequestModalButtons';
import ChannelDown from '@components/elements/images/channelDown';
import ChannelUp from '@components/elements/images/channelUp';
import Container from '@components/atoms/container/modalContainer';
import EpgEvent from '@shared/classes/epgEvent';
import FastEvent from '@shared/classes/fastEvent';
import FlavourConfig from '@shared/config/flavours';
import Pages from '@shared/types/enums/pages';
import RecordingModal from '@components/elements/modal/recordingModal';
import Subtitle from '@components/atoms/text/modalSubtitle';
import Title from '@components/atoms/text/modalTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { channelDown } from '@shared/store/slices/channels.slice';
import { channelUp } from '@shared/store/thunks/channels.thunk';
import { clearModal, modalSelector } from '@shared/store/slices/modal.slice';
import { selectRoute } from '@shared/store/slices/router.slice';
import { store } from '@shared/store/store';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';

/**
 * Displays the recording request modal.
 */
export default function RecordingRequestModal() {
  const { params } = useAppSelector(modalSelector);
  const route = useAppSelector(selectRoute);
  const dispatch = useAppDispatch();
  const asset = params?.asset as EpgEvent | FastEvent | undefined;
  const displayArrows = route.Page === Pages.ZAPPER;
  const title = TranslationManager.get(
    'MODAL.RECORDING.TITLE',
    FlavourConfig.appTitle
  );
  const subtitle = TranslationManager.get('MODAL.RECORDING.SUBTITLE');

  useKeyboard({
    canBeFocused: false,
    stopPropagation: true,
    keyDownHandler: () => null,
    keyUpHandler: (key) => {
      const { router } = store.getState();
      switch (key) {
        case 'BACK':
          dispatch(clearModal());
          break;
        case 'CHANNEL_DOWN':
          if (router.route.Page === Pages.ZAPPER) {
            dispatch(clearModal());
            dispatch(channelDown());
          }
          break;
        case 'CHANNEL_UP':
          if (router.route.Page === Pages.ZAPPER) {
            dispatch(clearModal());
            dispatch(channelUp());
            break;
          }
      }
    },
  });

  return (
    <Container>
      {displayArrows ? <ChannelUp /> : null}
      <RecordingModal asset={asset} />
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <Buttons asset={asset} />
      {displayArrows ? <ChannelDown /> : null}
    </Container>
  );
}
